import { SCHEMA_CONFIGS } from './config'

/**
 * Get organization schema data
 */
export const getOrganizationSchema = () => {
  return SCHEMA_CONFIGS || null
}
